import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ActionNotification from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/FileBlocking/ActionNotification';
import Rules from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/FileBlocking/Rules';

const FileBlocking = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Tabs>
        <TabList>
          <Tab>{t('policy.rules')}</Tab>
          <Tab>{t('policy.actionAndNotification')}</Tab>
        </TabList>
        <TabPanels py="2x">
          <TabPanel>
            <Rules applyBoundShow={false} blockAdditionalFileShow={false} />
          </TabPanel>
          <TabPanel>
            <ActionNotification
              advancedOptionShow={false}
              availableTokenShow={true}
              replaceFileNameShow={false}
              advancedSettings4FilesShow={true}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
export default React.memo(FileBlocking);
